/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'fill-connect': {
    width: 16,
    height: 16,
    viewBox: '-192 -192 768 896',
    data: '<path pid="0" d="M352 128h-48V16a16 16 0 00-32 0v112H112V16a16 16 0 00-32 0v112H32a32 32 0 00-32 32v32a32 32 0 0032 32v32c0 82.75 63.37 150.22 144 158.38V512h32v-97.62c80.63-8.16 144-75.63 144-158.38v-32a32 32 0 0032-32v-32a32 32 0 00-32-32zm-32 128a128 128 0 01-256 0v-32h256zm32-64H32v-32h320z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/fill-connect.js